<div class="shopping-center-type-view-container container" fxLayout="row" fxLayoutAlign="center center"
     [matTooltip]="definition?.description">
  <span>{{definition?.displayName || 'UNKNOWN_TYPE' | translate }}</span>
</div>
